// src/components/analytics/Charts/ABCDistributionChart.js
import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

const COLORS = {
  A: '#10b981', // Green
  B: '#3b82f6', // Blue
  C: '#f59e0b'  // Orange
};

function ABCDistributionChart({ data }) {
  if (!data) return null;

  const chartData = [
    { name: 'Class A (High Value)', value: data.class_a_products || 0, percentage: 80 },
    { name: 'Class B (Medium Value)', value: data.class_b_products || 0, percentage: 15 },
    { name: 'Class C (Low Value)', value: data.class_c_products || 0, percentage: 5 }
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="custom-tooltip">
          <p className="label">{data.name}</p>
          <p className="value">{data.value} products</p>
          <p className="percentage">~{data.percentage}% of revenue</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="abc-chart-container">
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, value }) => `${name.split(' ')[1]}: ${value}`}
            outerRadius={100}
            fill="#8884d8"
            dataKey="value"
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[entry.name.split(' ')[1]]} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}

export default ABCDistributionChart;
